import {FC, PropsWithChildren} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import classNames from 'classnames';
import {Rating} from 'components/Rating';
import {IReview} from 'modules/product-card/models/Review';

interface IProps extends PropsWithChildren {
    fullName?: string;
    rate?: number;
    review: IReview;
}

export const ProductReviewUser: FC<IProps> = ({fullName, rate, review, children}) => {
    const year = review.year;

    return (
        <div className={classNames(style.userWrapper)}>
            {children}
            <div className={style.userInfo}>
                {fullName && (
                    <Typography className={style.userName} color={'primary90'} variant={'p'}>
                        {fullName}
                    </Typography>
                )}
                <div className={style.userSubInfo}>
                    {Boolean(rate) && (
                        <Rating
                            classNames={{
                                ratingIcon: style.ratingIcon,
                                ratingIconsWrapper: style.ratingIconsWrapper,
                            }}
                            isReadOnly={true}
                            rate={rate}
                            withTitle={false}
                        />
                    )}
                    {year ? (
                        <Typography className={style.year} variant={'label-12-r'}>
                            Винтаж {year}
                        </Typography>
                    ) : null}
                </div>
            </div>
        </div>
    );
};
